import ArrowRight from '@components/CustomIcon/svg/ArrowRight';
import Calendar from '@components/CustomIcon/svg/Calendar';
import ComputerGraph from '@components/CustomIcon/svg/ComputerGraph';
import ComputerScreen from '@components/CustomIcon/svg/ComputerScreen';
import GraduationCap from '@components/CustomIcon/svg/GraduationCap';
import Hand from '@components/CustomIcon/svg/Hand';
import Headset from '@components/CustomIcon/svg/Headset';
import LightBulb from '@components/CustomIcon/svg/LightBulb';
import Locker from '@components/CustomIcon/svg/Locker';
import { FC } from 'react';
import * as styles from './index.css';

type Size = keyof typeof styles.sizes;

interface Props {
  name: keyof typeof sources;
  size: Size;
}

const sources = {
  'arrow-right': ArrowRight,
  lightbulb: LightBulb,
  headset: Headset,
  calendar: Calendar,
  computerscreen: ComputerScreen,
  hand: Hand,
  graduationcap: GraduationCap,
  computergraph: ComputerGraph,
  locker: Locker,
};

const CustomIcon: FC<Props> = ({ name, size }) => {
  if (!Object.keys(sources).includes(name)) {
    return null;
  }

  const Svg = sources[name];

  return <Svg dataTestId={`test_svg_${name}`} className={styles.sizes[size]} />;
};

export default CustomIcon;
